// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface DiscussionsMessageEmbed
 */
export interface DiscussionsMessageEmbed {
    /**
     * 
     * @type {string}
     * @memberof DiscussionsMessageEmbed
     */
    name: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof DiscussionsMessageEmbed
     */
    data: { [key: string]: string; };
}

export function DiscussionsMessageEmbedFromJSON(json: any): DiscussionsMessageEmbed {
    return {
        'name': json['name'],
        'data': json['data'],
    };
}

export function DiscussionsMessageEmbedToJSON(value?: DiscussionsMessageEmbed): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'name': value.name,
        'data': value.data,
    };
}


